import { IUser } from "types/user";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserStore = {
  user?: IUser;
  setUser: (user: IUser) => void;
  resetUser: () => void;
};

const useUserStore = create<UserStore>()(
  persist(
    (set) => ({
      user: undefined,
      token: undefined,
      setUser: (newUser: IUser) => set({ user: newUser }),
      resetUser: () => set({ user: undefined }),
    }),
    {
      name: "user",
      partialize: (state) => ({
        user: state.user,
      }),
    } as const
  )
);

export default useUserStore;
